exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".label-more-button-top{\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-line-pack: justify;\n      align-content: space-between;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n}\n\n.contracts-page .background-and-padding {\n  padding: 20px;\n  background: #f4f4f4;\n  border-radius: 10px;\n  margin-bottom: 20px;\n}\n\n.contracts-page .background-and-padding p{\n  margin-bottom: 0px;\n}\n\n.contracts-page .update-label-button-div {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: baseline;\n      align-items: baseline;\n}\n\n.contracts-page .update-label-button-div p{\n  margin-right: 15px;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/statics/css/contracts.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/statics/css/contracts.css
// module chunks = 0